import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_FMS_API + "/transactions/deposits";

export const depositsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "Deposits",
  tagTypes: ["Deposits"],
  idKey: "depositId",
  lookupMap: ({ depositId, referenceNo }) => ({
    value: depositId,
    label: referenceNo,
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListDepositsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      },
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitDeposits: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnDeposits: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveDeposits: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectDeposits: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelDeposits: mutation(`${baseURL}/cancel`, mutationOptions("save")),
  }),
});

export const {
  useGetDepositsQuery,
  useGetListDepositsForViewersQuery,
  useExportDepositsMutation,
  useFindDepositsQuery,
  useLookUpDepositsMutation,
  useSaveDepositsMutation,
  useSubmitDepositsMutation,
  useReturnDepositsMutation,
  useApproveDepositsMutation,
  useRejectDepositsMutation,
  useCancelDepositsMutation,
  useDeleteDepositsMutation,
} = depositsAPI;
